// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dxczfuavfghrlfwtazfi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR4Y3pmdWF2Zmdocmxmd3RhemZpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAzMDU3OTgsImV4cCI6MjA4NTg4MTc5OH0.GKluIgpPk1SDKjkDufRyxeyIN87OfcKbbavHXZvHndc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});